import React from 'react';
import { Clock, Target, TrendingUp, CheckCircle, FileCheck, Award } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  Clock,
  Target,
  TrendingUp,
  CheckCircle,
  FileCheck,
  Award
};

export const WhyChooseUs = () => {
  return (
    <section id="why-choose" className="py-20 bg-gradient-to-br from-blue-50 via-white to-emerald-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Why Choose Us
          </div>
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
            Delivering Excellence Every Day
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            We offer 24/7 operational excellence, single-point accountability, and value-added services — all designed to drive efficiency, safety, and compliance.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 dark:border-gray-700"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                  {item.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};